import { render, staticRenderFns } from "./pc-upload.vue?vue&type=template&id=60ad1e00&scoped=true"
import script from "./pc-upload.vue?vue&type=script&lang=ts"
export * from "./pc-upload.vue?vue&type=script&lang=ts"
import style0 from "./pc-upload.vue?vue&type=style&index=0&id=60ad1e00&prod&lang=less&scoped=true"
import style1 from "./pc-upload.vue?vue&type=style&index=1&id=60ad1e00&prod&lang=less&scoped=true"
import style2 from "./pc-upload.vue?vue&type=style&index=2&id=60ad1e00&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../../../entries/portal/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60ad1e00",
  null
  
)

export default component.exports